import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const SelectChallenge = gql`
  mutation SelectChallenge($challengeId: String!) {
    selectChallenge(challengeId: $challengeId) {
      ... on SelectChallengeError {
        __typename
        ...error
      }
      ... on SelectChallengeSuccess {
        __typename
        challengeContext
        challengeId
        challengeState
        challengeType
      }
    }
  }
  ${error}
`;
export default SelectChallenge;
